"use client";

import classNames from "classnames";
import { H1 } from "components/ui/H";
import { Children, Fragment, memo, ReactNode } from "react";

type spacingSize = "sm" | "md" | "lg" | "xl" | "xxl";

type Props = {
  children?: ReactNode;
  spacing?: spacingSize;
};

const getSpacingClass = (spacing: spacingSize, isFirst: boolean): string => {
  if (isFirst) return "";
  switch (spacing) {
    case "sm":
      return "pt-sm";
    case "md":
      return "pt-md";
    case "lg":
      return "pt-lg";
    case "xl":
      return "pt-xl";
    case "xxl":
      return "pt-xxl";
    default:
      return "pt-md";
  }
};

export function Stack({ children, spacing = "md" }: Props) {
  return (
    <div>
      {Children.map(children, (child, i) => {
        if (child !== null && child !== undefined) {
          return (
            <div key={i} className={getSpacingClass(spacing, i === 0)}>
              {child}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export const Row = memo(function Row({ title, children }: { children: ReactNode; title: string }) {
  return (
    <Fragment>
      <H1 className="mb-xs">{title}</H1>
      {children}
    </Fragment>
  );
});

export const Pair = ({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & Record<string, unknown>) => (
  <div className={classNames("mt-sm flex w-188", className)} {...props}>
    {children}
  </div>
);

export const Header = ({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & Record<string, unknown>) => (
  <div
    className={classNames(
      "text-md text-black-56 font-default w-52 shrink-0 text-justify leading-[1.25] normal-case",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const Value = ({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & Record<string, unknown>) => (
  <div
    className={classNames(
      "text-black-56 font-default text-justify text-sm leading-[1.25] normal-case",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
